import React from 'react';
import gpt3Logo from '../../assets/favicon.ico';
import './footer.css';

const Footer = () => (
    <div className="gpt3__footer section__padding">
    <div className="gpt3__footer-links">
      <div className="gpt3__footer-links_div">
      <h4><a href="#home">Home</a></h4>
      <h4><a href="#wgpt3">What is GPT3 ?</a></h4>
      <h4><a href="#possibility">Open AI</a></h4>
      <h4><a href="#library">Library</a></h4>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Company</h4>
        <p>Terms & Conditions </p>
        <p>Privacy Policy</p>
        <p>Contact</p>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Get in touch</h4>
        <p>Sinhgad Institutes Pune</p>
        <p>020-1234-456</p>
        <p><a href="https://avezqureshi.netlify.app/">Developer Site</a></p>
      </div>
    </div>

    <div className="gpt3__footer-copyright">
      <p>@2023 <a href="https://avezqureshi.netlify.app/" target="_blank">Avez Qureshi</a>  All rights reserved.</p>
    </div>
  </div>
);

export default Footer;
